export enum WebSocketMessageContextConnectionManager {
  ConnectionEstablished = 'WebsocketMessageContextConnectionManager_ConnectionEstablished',
  Pong = 'WebsocketMessageContextConnectionManager_Pong',
  HealthCheck = 'WebsocketMessageContextConnectionManager_HealthCheck'
}
